document.addEventListener('DOMContentLoaded', function() {
  function initResenasSlider() {
    const container = document.getElementById('ResenasSliderJS');
    if (!container) return;

    const track = container.querySelector('.resenas-slider-track');
    const slides = Array.from(track.querySelectorAll('.resena-slide-item'));
    const dotsContainer = document.getElementById('ResenasSliderDotsJS');
    
    if (slides.length <= 1) {
      if (dotsContainer) dotsContainer.innerHTML = '';
      return;
    }

    // Generar dots dinámicos
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('resenas-slider-dot');
        if (index === 0) dot.classList.add('dot-active');
        dot.setAttribute('aria-label', `Ir a reseña ${index + 1}`);
        dotsContainer.appendChild(dot);
      });
    }

    const dots = Array.from(dotsContainer.querySelectorAll('.resenas-slider-dot'));
    let currentIdx = 0;

    function goToSlide(nextIdx) {
      slides[currentIdx].classList.remove('slide-active');
      dots[currentIdx].classList.remove('dot-active');
      
      slides[nextIdx].classList.add('slide-active');
      dots[nextIdx].classList.add('dot-active');
      currentIdx = nextIdx;
    }

    // Eventos para los dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goToSlide(index));
    });

    // Auto-rotación simple de seguridad
    let interval = setInterval(() => {
      let next = (currentIdx + 1) % slides.length;
      goToSlide(next);
    }, 6000);

    container.addEventListener('mouseenter', () => clearInterval(interval));
  }

  initResenasSlider();

  // Escucha del editor de Shopify para refrescar al agregar o mover bloques
  document.addEventListener('shopify:section:load', initResenasSlider);
  document.addEventListener('shopify:section:select', initResenasSlider);
});
